import { useI18n } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';

import { useContributionsPageState } from '#src/app/pages/accountSettings/contributions/main/pageContext';

type Result = ModelHookResult<
	undefined,
	{
		validate: () => Promise<boolean>;
	}
>;

export function useValidate(): Result {
	const { translate } = useI18n();
	const [{ userName }, { setNameErrorMessage, setLoadingUpdatePaymentMethod }] = useContributionsPageState();
	const track = useTracking();

	const validate = async () => {
		void track('sponsor_cc_update_submit');
		const nameValid = userName.trim().length > 0;
		if (!nameValid) {
			void track('sponsor_cc_update_cc_modal_error');
			setNameErrorMessage(translate('fe.errors.credit_card.name'));
			setLoadingUpdatePaymentMethod(false);
		}
		return Promise.resolve(nameValid);
	};
	return {
		actions: {
			validate,
		},
	};
}
